import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store/useStore';
import { LoadingScreen } from '../ui/LoadingScreen';
import { UserRole } from '../../types/auth';
import { isExecutive } from '../../utils/auth';

interface AuthGuardProps {
  children: React.ReactNode;
  requiredRole?: UserRole | UserRole[];
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children, requiredRole }) => {
  const navigate = useNavigate();
  const { currentUser } = useStore();
  const isLoading = useStore(state => state.isLoading);

  useEffect(() => {
    if (!isLoading && !currentUser) {
      navigate('/signin');
      return;
    }

    if (requiredRole && currentUser) {
      const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
      
      // Allow both CEO and CFO for executive routes
      if (roles.includes('CEO') && isExecutive(currentUser.role)) {
        return;
      }
      
      // Check other roles normally
      if (!roles.includes(currentUser.role)) {
        navigate('/unauthorized');
        return;
      }
    }
  }, [currentUser, isLoading, navigate, requiredRole]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!currentUser) {
    return null;
  }

  return <>{children}</>;
};